import { Component, EventEmitter, HostListener, Input, OnInit, Optional, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, EnvironmentConfig, EVENTS, EventService, IAdmin, IUser, TrackingService } from '@clooper/core';

@Component({
  selector: 'app-webapp-side-bar',
  templateUrl: './webapp-side-bar.component.html',
  styleUrls: ['./webapp-side-bar.component.scss']
})
export class WebappSideBarComponent implements OnInit {
  @Input() showMenu = false;
  @Output() onMenuClosed = new EventEmitter<boolean>();
  @Input() user: IUser;
  @Input() admin: IAdmin;

  @Input() menuItems: any;
  @Input() subItems: any;
  searchBarFlag: boolean;

  screenSize: number = window.innerWidth;


  @HostListener('window:resize', ['$event'])
  onResize(_: any) {
    this.screenSize = window.innerWidth;
  }


  constructor(
    private router: Router,
    @Optional() private eventSrv: EventService,
    @Optional() private authService: AuthService

  ) {
  }



  ngOnInit(): void {
    this.user = this.authService.getAuthorizedUser()
    this.eventSrv.observeUser.subscribe((user: any) => {
      if (user) {
        this.user = user
      }
    })
  }

  closeMenu() {
    this.showMenu = false;
    this.onMenuClosed.emit(this.showMenu);
  }

  gotoPreference(user: any) {
    if (user.matching_locations?.length === 0) {
      this.router.navigateByUrl('/tenant-profile/create/start')
    }
  }

  logout() {
    this.authService.signout()
    this.router.navigate(['/login'])
  }

  gotoAction(item: any) {
    if (item.name === 'Find a property' && this.screenSize > 768) {
      this.searchBarFlag = true
    } else {
      this.router.navigateByUrl(item.url)
    }
    this.closeMenu()
  }
}
